import React from "react";
import { NavLink } from "react-router-dom";

export type TermData = {
  id: number;
  term_meta: {
    color: string;
    icon: string;
    text: string;
  };
  slug: string;
  url: string;
};

// TermData[]の中からterm_idsにidのあるものだけを抽出する
export const filterTerms = (
  term_ids: number[],
  allTerms: TermData[]
): TermData[] => allTerms.filter((term) => term_ids.includes(term.id));

const Term: React.FC<{
  term: TermData;
  classNamePrefix?: string;
}> = ({ term, classNamePrefix = "term" }) => {
  return (
    <>
      <NavLink
        to={term.url}
        className={`${classNamePrefix}__link`}
        style={{ color: term.term_meta?.color || "transparent" }}
        onClick={(e) => e.stopPropagation()}
      >
        <div
          className={`${classNamePrefix}__icon`}
          dangerouslySetInnerHTML={{ __html: term.term_meta?.icon }}
        ></div>
        <div className={`${classNamePrefix}__text`}>{term.term_meta?.text}</div>
      </NavLink>
    </>
  );
};

export default Term;
